module.exports = __webpack_public_path__ + "img/box6-06.98ca9402.png";